export default "__VITE_ASSET__B4b83JJ3__"